import React from 'react';

import {
  FormContainer,
  Heading,
  Subheading,
  InlineAnchor,
} from './styles_auth';
import { FormFooter } from './FormFooter';

export const PortalDisabledPage = () => {
  return (
    <FormContainer>
      <Heading bold>Portal access disabled</Heading>
      <Subheading>
        Your portal access has been disabled. Please{' '}
        <InlineAnchor href="mailto:support@anyroad.com">
          contact us
        </InlineAnchor>{' '}
        if you have any questions.
      </Subheading>
      <FormFooter />
    </FormContainer>
  );
};
